// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBox_search__2Vwee","fa":"SearchBox_fa__aY5xn"};